import SwitchStatus from './switch-status.vue';

export const sexList = [
    {label: 'settings.manandwomen', value: 0},
    {label: 'settings.man', value: 1},
    {label: 'settings.women', value: 2}
];
export const roleList = [
    {label: 'settings.admin', value: 1},
    {label: 'settings.businessAdmin', value: 2},
    {label: 'settings.businesser', value: 3}
];

export const orgTableColumns = [
    {
        prop: 'dstatus',
        renderHeader: () => 'settings.status',
        // sort: true,
        align: 'left',
        fixed: 'left',
        width: '100px',
        render: () => 'switchStatus',
        component: SwitchStatus,
        changeStatus: 'changeStatus'
    },
    {
        prop: 'real_name',
        renderHeader: () => 'settings.name',
        width: '80px',
        fixed: 'left',
        align: 'left'
    },
    {
        prop: 'phone',
        renderHeader: () => 'settings.phone',
        width: '120px',
        align: 'left'
    },
    {
        prop: 'role_name',
        renderHeader: () => 'settings.role',
        width: '100px',
        fixed: 'left',
        align: 'left',
        // format: (row: any, t: Function) => {
        //     const currentRole = roleList.find(a => a.value === +row.role_id);
        //     return currentRole ? t(currentRole.label) : '--';
        // }
    },
    {
        prop: 'email',
        renderHeader: () => 'settings.email',
        align: 'left',
        width: '180px'
    },
    {
        prop: 'sex',
        renderHeader: () => 'settings.sex',
        format:(row:any,t:Function)=>{
            const currentSex = sexList.find(a => a.value === +row.sex);
            return currentSex ? t(currentSex.label) : t('settings.manandwomen');
        }
    },
    {
        prop: 'org_name',
        renderHeader: () => 'settings.forDepartment',
        width: '120px'
    },
    {
        prop: 'post_name',
        renderHeader: () => 'settings.postname',
        width: '100px'
    },
    {
        prop: 'org_leader',
        renderHeader: () => 'settings.departmentLeader',
        width: '100px'
    },
    {
        prop: 'created_time',
        renderHeader: () => 'settings.created_at',
        width: '150px'
    },

];
